import React from "react";
import CustomerPerformanceWidget from "./CustomerPerformanceWidget";

// "Tiered Customer Performance" widget — operational change-job "issues" for
// orders whose customer had a priority number or was "New" at order creation.
// Thin wrapper over the shared CustomerPerformanceWidget; the backend applies
// the tier filter behind the TieredCustomerPerformance endpoint.
const ROWS = [
  { key: "uncoveredLabor", label: "Uncovered Labor", slug: "uncovered-labor" },
  { key: "uncoveredMaterialStockout", label: "Uncovered Material Stockout", slug: "uncovered-material-stockout" },
  { key: "qualities", label: "Qualities", slug: "qualities" },
  { key: "shortages", label: "Shortages", slug: "shortages" },
];

const TieredCustomerPerformance = (props) => (
  <CustomerPerformanceWidget
    {...props}
    endpoint="TieredCustomerPerformance"
    title="Tiered Customer Performance"
    rows={ROWS}
    countLabel="Jobs with Issue"
  />
);

export default TieredCustomerPerformance;
